import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { WdxBaseInputLabelIdClass } from '@wdx/shared/components/abstract-classes';

@Component({
    selector: 'wdx-radio-tile',
    templateUrl: './wdx-radio-tile.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class WdxRadioTileComponent extends WdxBaseInputLabelIdClass {
    @Input() label?: string | null;
    @Input() subLabel?: string;
    @Input() set value(val: string) {
        this._value = val;
    }

    get value(): string {
        return this._value as string;
    }
}
